import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  avlIntDataSelector,
  loadingSelector,
} from '@store/serviceIntegrations/availableIntegrations/selectors';
import { fetchData } from '@store/serviceIntegrations/availableIntegrations/actions';
import { Retry } from '@components/common';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';
import PartnerCard from './partner-card';
import { SectionTitle, AvailableIntWrapper, ContentWrapper } from './styled';
import { getIntegrationPartners } from './partners';
import EnablePartnerModal from './enable-partner-modal';
import { siPagerDutyDisplayFeatureSelector } from '@store/common/selectors';

function AvailableIntegrations() {
  const dispatch = useDispatch();

  const { loading, showError } = useSelector(loadingSelector);
  let { data: partners = [] } = useSelector(avlIntDataSelector);
  const displaySiPagerduty = useSelector(siPagerDutyDisplayFeatureSelector);
  const partnerList = getIntegrationPartners(CURRENT_PRODUCT_MODE);

  partners = partners
    .filter((partner) => {
      if (partner.name === 'PagerDuty') return displaySiPagerduty;
      return partner.name in partnerList;
    })
    .map((partner) => {
      const newPartner = { ...partner };
      newPartner.logo = partnerList[partner.name]?.logo;
      newPartner.featureFlagSelector = partnerList[partner.name]?.featureFlag;

      return newPartner;
    });

  useEffect(() => {
    dispatch(fetchData());
  }, []);

  const retryAction = () => dispatch(fetchData());

  return (
    <ContentWrapper>
      <SectionTitle>Available Integrations</SectionTitle>

      <Retry isLoading={loading} showError={showError} fetchData={retryAction}>
        <AvailableIntWrapper>
          {partners.map((partner) => {
            const partnerDetails = {
              ...partner,
            };

            return <PartnerCard key={partner.name} partner={partnerDetails} />;
          })}
        </AvailableIntWrapper>
      </Retry>
      <EnablePartnerModal />
    </ContentWrapper>
  );
}

export default AvailableIntegrations;
